import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progressWrapper"
}
const _hoisted_2 = { key: 1 }



export default /*@__PURE__*/_defineComponent({
  __name: 'PendingButton',
  props: [`isPending`, `send`,`color`,`text`,`center`],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_component_BaseButton, {
    color: _ctx.color,
    center: _ctx.center,
    onClick: _ctx.send,
    class: "button"
  }, {
    default: _withCtx(() => [
      (_ctx.isPending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              color: "white",
              class: "progress",
              indeterminate: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
    ]),
    _: 1
  }, 8, ["color", "center", "onClick"]))
}
}

})